import { render, staticRenderFns } from "./HouseSidebar.vue?vue&type=template&id=a794364e"
import script from "./HouseSidebar.vue?vue&type=script&lang=js"
export * from "./HouseSidebar.vue?vue&type=script&lang=js"
import style0 from "./HouseSidebar.vue?vue&type=style&index=0&id=a794364e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./HouseSidebar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports